import { useNavigate } from '@tanstack/react-router'
import { AlertTriangle } from 'lucide-react'
import type { LeagueSummary } from '@/features/league/types'
import styles from './ActionCenterCard.module.css'

type ActionCenterCardProps = {
  leagues: LeagueSummary[]
}

function needsSquad(league: LeagueSummary): boolean {
  return league.squadPreview.length === 0 && league.competitionStatus !== 'FINISHED'
}

export function ActionCenterCard({ leagues }: ActionCenterCardProps) {
  const navigate = useNavigate()
  const hasPending = leagues.some(needsSquad)
  if (!hasPending) return null

  function handleClick() {
    void navigate({ to: '/ligas' })
  }

  return (
    <div className={styles.card}>
      <div className={styles.body}>
        <AlertTriangle size={18} className={styles.headerIcon} />
        <span className={styles.message}>Você possui ligas sem escalação montada.</span>
      </div>
      <button type="button" className={styles.cta} onClick={handleClick}>
        Vá para suas ligas
      </button>
    </div>
  )
}
